import { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Camera, AlertCircle } from 'lucide-react';
import api from '@/lib/api';

export default function PhotographerVerify() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token');
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!token) {
      setError('missing');
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const r = await api.post('/photographer/auth/verify-magic-link', { token });
        if (cancelled) return;
        localStorage.setItem('photographer_token', r.data.access_token);
        localStorage.setItem('photographer', JSON.stringify(r.data.photographer));
        navigate('/photographer/dashboard', { replace: true });
      } catch {
        if (!cancelled) setError('invalid');
      }
    })();
    return () => { cancelled = true; };
  }, [token, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-teal-50 to-cyan-50 flex items-center justify-center p-4">
      <Card className="max-w-md w-full p-8 text-center">
        {!error ? (
          <>
            <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-gradient-to-br from-emerald-500 to-teal-600 mx-auto mb-4">
              <Camera className="w-7 h-7 text-white animate-pulse" />
            </div>
            <h1 className="text-xl font-semibold text-slate-900">{t('photographer.verifyingTitle')}</h1>
          </>
        ) : (
          <>
            <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-rose-100 text-rose-600 mx-auto mb-4">
              <AlertCircle className="w-7 h-7" />
            </div>
            <h1 className="text-xl font-semibold text-slate-900 mb-2">{t('photographer.verifyError')}</h1>
            <Link to="/photographer/login">
              <Button className="mt-2">{t('photographer.backToLogin')}</Button>
            </Link>
          </>
        )}
      </Card>
    </div>
  );
}
